import { useEffect, useState, useCallback } from "react";
import { Bike, Store, Trash2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg, formatARS } from "@/lib/api";

const fmtDate = (iso) => new Date(iso).toLocaleString("es-AR", { dateStyle: "short", timeStyle: "short" });

export const AdminOrders = () => {
  const [orders, setOrders] = useState(null);
  const load = useCallback(() => {
    http.get("/admin/orders").then((r) => setOrders(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const del = async (o) => {
    if (!window.confirm(`¿Eliminar el pedido #${o.number} del historial?`)) return;
    try { await http.delete(`/admin/orders/${o.id}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="space-y-3 pb-10" data-testid="admin-orders">
      <div className="flex items-center justify-between">
        <p className="text-sm text-[#A89F91]">{orders ? `${orders.length} pedidos` : "Cargando..."}</p>
        <button onClick={load} className="inline-flex items-center gap-1 text-xs text-amber-400" data-testid="orders-refresh-btn"><RefreshCw className="w-3.5 h-3.5" /> Actualizar</button>
      </div>
      {orders?.length === 0 && <p className="text-center text-[#A89F91] py-10" data-testid="orders-empty">Todavía no hay pedidos.</p>}
      {orders?.map((o) => (
        <article key={o.id} className="rounded-2xl bg-[#1C1515] border border-[#2E2323] p-4 space-y-2" data-testid={`order-card-${o.number}`}>
          <div className="flex items-center gap-2">
            <span className="font-price text-2xl text-amber-400">#{o.number}</span>
            <span className="text-xs text-[#A89F91]">{fmtDate(o.created_at)}</span>
            <span className="ml-auto inline-flex items-center gap-1 text-[10px] uppercase font-bold px-2 py-1 rounded-full bg-white/5 border border-[#2E2323]">
              {o.delivery_type === "delivery" ? <><Bike className="w-3 h-3" /> Delivery</> : <><Store className="w-3 h-3" /> Retiro</>}
            </span>
            <button onClick={() => del(o)} className="p-1 text-[#A89F91] hover:text-red-400" data-testid={`order-delete-btn-${o.number}`}><Trash2 className="w-4 h-4" /></button>
          </div>
          <p className="text-sm font-semibold">{o.customer_name} · <span className="text-[#A89F91] font-normal">{o.customer_phone}</span></p>
          {o.delivery_type === "delivery" && <p className="text-xs text-[#d9cfc2]">{o.delivery.address} {o.delivery.number} · Entre {o.delivery.between} · Ref: {o.delivery.reference}</p>}
          <ul className="text-sm text-[#d9cfc2] space-y-0.5">
            {o.items.map((it, i) => <li key={i}>{it.qty}x {it.name}{it.details?.length ? <span className="text-xs text-[#A89F91]"> ({it.details.join(", ")})</span> : null}</li>)}
          </ul>
          {o.notes && <p className="text-xs text-amber-200">Notas: {o.notes}</p>}
          <div className="flex items-end justify-between pt-2 border-t border-[#2E2323]">
            <span className="text-xs text-[#A89F91]">
              {o.payment_method === "efectivo" ? `Efectivo${o.cash_amount ? ` · abona con ${formatARS(o.cash_amount)}` : ""}` : "Transferencia"}
            </span>
            <span className="font-price text-xl" data-testid={`order-total-${o.number}`}>{formatARS(o.total)}</span>
          </div>
          {o.receipt && <a href={o.receipt} target="_blank" rel="noreferrer" download={`comprobante-${o.number}.jpg`}><img src={o.receipt} alt="Comprobante" className="w-20 h-24 object-cover rounded-lg border border-[#2E2323]" data-testid={`order-receipt-${o.number}`} /></a>}
        </article>
      ))}
    </div>
  );
};
